import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import authSlice from "./slices/authSlice/authSlice";
import routingSlice from "./slices/routingSlice/routingSlice";
import profileSlice from "./slices/profileSlice/profileSlice";
import modalStatesSlice from "./slices/modalStatesSlice/modalStatesSlice";
import applicationBankListSlice from "./slices/applicationBankListSlice/applicationBankListSlice";
import { api } from "./api/apiCore";
import notificationsSlice from "./slices/notificationsSlice/notificationsSlice";
import applicationBankSlice from "./slices/applicationBankSlice/applicationBankSlice";
import { setupListeners } from "@reduxjs/toolkit/query";

const store = configureStore({
  reducer: {
    authSlice: authSlice,
    routingSlice: routingSlice,
    profileSlice: profileSlice,
    applicationBankListSlice: applicationBankListSlice,
    notificationsSlice: notificationsSlice,
    applicationBankSlice: applicationBankSlice,
    modalStatesSlice: modalStatesSlice,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    api.middleware,
    thunkMiddleware,
  ],
  devTools: process.env.REACT_APP_IS_BUILD !== "PRODUCTION",
});
setupListeners(store.dispatch);
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
